<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="bg-second-migas">
  <div class="container mt-cab-fixed">
    <div class="pre-content">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Poseedores</li>
          <li *ngIf="flagRuta" class="breadcrumb-item"><a (click)="volver()" style="cursor: pointer;">Búsqueda de Poseedores</a>
          </li>
          <li class="breadcrumb-item active">Datos de Poseedor</li>
        </ol>
      </nav>
      <div class="d-flex content-title">
        <div class="d-flex">
          <h2 class="title-pag">Datos de Poseedor {{id}}</h2>
          <div *ngIf="datosCargados" class="custom-container" [ngStyle]="styleEstadoPoseedores" style="font-weight: 600;">
            <div>
              <span style="font-size: larger; padding-top: 5px; display: flex;">
                <mat-icon class="show-icon" [ngStyle]="{'color': styleEstadoPoseedores.color + ' !important'}">{{ iconEstado }}</mat-icon>
              </span>
            </div>
            <div>
              <span class="info-texto-estado" [ngStyle]="{'color': styleEstadoPoseedores.color + ' !important'}" style="font-weight: 600; display: block;">
                {{textoEstado}}</span>
            </div>
            <div *ngIf="this.poseedorInfo?.estado?.infoAdicional" style="padding-top: 8px;">
              <div class="tool-help" matTooltip={{this.poseedorInfo?.estado?.infoAdicional}}>
                <span>i</span>
              </div>
            </div>
          </div>
        </div>
        <div class="nota mt-2">Los campos señalados con asterisco <span class="oblig">*</span> son obligatorios
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MIGAS DE PAN Y TÍTULO -->

<div class="container">
  <div class="card-ficha">
    <div class="card-body">
      <div class="ficha-2col">
        <div class="col-tab-list">
          <ul class="list">
            <li [ngClass]=" {'active':(selectedMenu===1)}"
              (click)="!canAccessContinuarAll(1) ? loadNumMenu(1) : mensajeValidacion()">
              1. Datos generales
            </li>
            <li [ngClass]="{'active':(selectedMenu===2)}"
              (click)="!canAccessContinuarAll(1) ? loadNumMenu(2) : mensajeValidacion()">
              2. Datos de contacto
            </li>
            <li [ngClass]="{'active':(selectedMenu===3)}"
              (click)="!canAccessContinuarAll(1) ? loadNumMenu(3) : mensajeValidacion()">
              3. Direcciones
            </li>
            <li *ngIf="this.poseedorInfo?.contratoGestor" [ngClass]="{'active':(selectedMenu===4)}"
              (click)="!canAccessContinuarAll(1) ? loadNumMenu(4) : mensajeValidacion()">
              4. Previsión de residuos de envases
            </li>
            <li *ngIf="canAccessDocumentos() && estadoPoseedor!>=3 && this.poseedorInfo?.contratoGestor" [ngClass]="{'active':(selectedMenu===5)}"
              (click)="loadNumMenu(5)">
              5. Documentos
            </li>
            <li *ngIf="canAccessDocumentos() && estadoPoseedor!>=3 && !this.poseedorInfo?.contratoGestor" [ngClass]="{'active':(selectedMenu===5)}"
              (click)="loadNumMenu(5)">
              4. Documentos
            </li>
          </ul>
        </div>
        <div *ngIf="selectedMenu===1" class="col-content">
          <lib-holders-detail-general-data [poseedorInfo]="poseedorInfo" (refrescarPoseedorEvent)="refrescar(1)">
          </lib-holders-detail-general-data>
        </div>
        <div *ngIf="selectedMenu===2" class="col-content">
          <lib-holders-detail-contact-data [poseedorInfo]="poseedorInfo" (refrescarPoseedorEvent)="refrescar(2)">
          </lib-holders-detail-contact-data>
        </div>
        <div *ngIf="selectedMenu===3" class="col-content">
          <lib-holders-detail-address [poseedorInfo]="poseedorInfo" (refrescarPoseedorEvent)="refrescar(3)">
          </lib-holders-detail-address>
        </div>
        <div *ngIf="selectedMenu===4" class="col-content">
          <lib-holders-waste-forecast [poseedorInfo]="poseedorInfo" (refrescarPoseedorEvent)="refrescar(4)">
          </lib-holders-waste-forecast>
        </div>
        <div *ngIf="selectedMenu===5" class="col-content">
          <lib-holders-detail-documents [poseedorInfo]="poseedorInfo" (refrescarPoseedorEvent)="refrescar(5)">
          </lib-holders-detail-documents>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="button-actions">
      <!-- Guardar y Continuar -->
      <button type="button" *ngIf="canAccessCancelar(selectedMenu)" class="btn btn-outline-primary"
        (click)="cancelar()">
        <div class="text-icon">Cancelar</div>
      </button>
      <button type="button" *ngIf="canAccessVolver()" class="btn btn-outline-primary" (click)="volver()">
        <div class="text-icon">Volver</div>
      </button>
      <button type="button" *ngIf="canAccessAnteriorAll(selectedMenu) && selectedMenu!==1"
        class="btn btn-outline-primary" (click)="anterior()">
        <div class="text-icon">Anterior</div>
      </button>
      <button type="button" *ngIf="canAccessContinuarAll(selectedMenu) || canAccessGuardar(selectedMenu)"
        class="btn btn-outline-primary">
        <div class="text-icon" (click)="guardar(selectedMenu)">{{continuarName(selectedMenu)}}<span
            *ngIf="continuarName(selectedMenu)!='Guardar'" class="icon-arrow-right"></span></div>
      </button>
      <button type="button"
        *ngIf="canAccessFinalizar(selectedMenu) && (selectedMenu===4 || (selectedMenu===3 && !this.poseedorInfo?.contratoGestor))"
        class="btn btn-outline-primary" (click)="finalizar()">
        <div class="text-icon">Finalizar</div>
      </button>
    </div>
  </div>
